/**
 * useLogReadOnMount — fire a read-event log when a sensitive surface mounts.
 * Pulls the viewer's role/name from RoleContext when available; safe to call
 * unconditionally — falls back to "unknown" without throwing.
 */
import { useEffect } from "react";
import { useRole } from "@/data/RoleContext";
import { logReadEvent, type ReadSensitivity } from "@/data/accounting/audit/readEventLog";

export function useLogReadOnMount(
  surface: string,
  opts?: {
    sensitivity?: ReadSensitivity;
    entityRef?: { kind: string; id: string };
  },
) {
  const { role } = useRole();
  const sensitivity = opts?.sensitivity ?? "default";
  const entityKind = opts?.entityRef?.kind;
  const entityId = opts?.entityRef?.id;
  useEffect(() => {
    logReadEvent({
      surface,
      sensitivity,
      viewerRole: role,
      entityRef: entityKind && entityId ? { kind: entityKind, id: entityId } : undefined,
    });
    // intentional: log once per (surface, entity) mount
  }, [surface, sensitivity, role, entityKind, entityId]);
}
